export default __webpack_public_path__ + "static/media/babar-azam.54f4c8f1.jpg";